import { RightOutlined } from '@ant-design/icons';
import { Divider } from 'antd';
import React from 'react';

import { WL_COMPANY_PRIMARY_COLOR } from '@portal/config/env';

interface ActionDisplayProps {
  items: Array<{
    title: string;
    name?: string;
    icon?: React.SVGProps<SVGSVGElement>;
    rightIcon?: React.SVGProps<SVGSVGElement>;
    text?: string | null;
    onClick?: () => void;
    hidden?: boolean;
    disabled?: boolean;
    id?: string;
  }>;
  className?: string;
  containerClassName?: string;
}

const ActionDisplay = ({
  items,
  containerClassName,
  className,
}: ActionDisplayProps) => {
  return (
    <>
      {items
        .filter((item) => !item.hidden)
        .map((item) => (
          <div
            className={`action-display${item.disabled ? '--disabled' : ''}`}
            key={item.title}
          >
            <div
              {...{ testId: `my-account_${item.id}_click` }}
              className={`action-display__action ${containerClassName}`}
              onClick={() => {
                if (item.onClick && !item.disabled) {
                  item.onClick();
                }
              }}
            >
              <div className="action-display__action__options">
                {item.icon ? (
                  <span className="action-display__action__options__icon">
                    {item.icon}
                  </span>
                ) : null}
                <div
                  className={`action-display__action__options__container ${className}`}
                >
                  <p className="action-display__action__options__title">
                    {item.title}
                  </p>
                  <p className="action-display__action__options__text">
                    {item.text}
                  </p>
                </div>
              </div>

              {item.onClick ? (
                <span className="action-display__action__options__arrow-icon">
                  {item.rightIcon ? (
                    item.rightIcon
                  ) : (
                    <RightOutlined
                      style={{
                        color: WL_COMPANY_PRIMARY_COLOR,
                        fontSize: 20,
                      }}
                    />
                  )}
                </span>
              ) : null}
            </div>
            <Divider className="action-display__action__options__divider" />
          </div>
        ))}
    </>
  );
};

export default ActionDisplay;
